const initialState = null;

export default function UserReducer(state = initialState, action) {
  switch (action.type) {
    case 'PUT_USER':
      return action.user;
    case 'CLEAR_USER':
      return {};
    default:
      return state;
  }
}